export const RPC_CALLS = {
  eth_call: 'eth_call',
  eth_gasPrice: 'eth_gasPrice',
  eth_getLogs: 'eth_getLogs',
  eth_getBalance: 'eth_getBalance',
  eth_getCode: 'eth_getCode',
  eth_getBlockByHash: 'eth_getBlockByHash',
  eth_getBlockByNumber: 'eth_getBlockByNumber',
  eth_getStorageAt: 'eth_getStorageAt',
  eth_getTransactionByHash: 'eth_getTransactionByHash',
  eth_getTransactionReceipt: 'eth_getTransactionReceipt',
  eth_getTransactionCount: 'eth_getTransactionCount',
  eth_estimateGas: 'eth_estimateGas',
} as const;
